import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { validateEventCalendarSearch } from "@/features/events/routeSearch";
export const Route = createFileRoute("/events/")({
  component: lazyRouteComponent(
    () => import("@/pages/EventsPage"),
    "EventsPage",
  ),
  validateSearch: validateEventCalendarSearch,
});
